export class CensusLiteMethod {
  public static GroupDetails: string =
    'broker/{brokerId}/groupsandquotes/{marketSegmentId}';
  public static PostalDetails: string = 'postalcodes/';
  public static SICCode: string = 'siccode/';
  public static GetExistingGroup: string = 'group/{id}';
  public static AddGroup: string = 'group';
  public static PostMaterCensusDetail: string = 'census';
  public static PostMasterCensusDetailForList: string = 'InsertMembers';
}

export class PlanLiteMethod {
  public static QuotableDates: string = 'plans/{stateId}/quotabledates';
}

export class NQSPlanApiMethod {
  public static GetCarriers: string = 'literating/GetLiteCarriers';
  public static GetLiteWrapCarriers: string = 'literating/GetWrapLiteCarriers';
  public static GetPackages: string = 'literating/GetNHWSQuotablePlans';
  public static GetPackagesNewHire: string =
    'literating/GetNewHireQuotablePlans';
  public static GetPlanByPackageIdNewHire: string =
    'literating/GetPlansbyByPackageId';
  public static GetNetworksLite: string = 'literating/GetNetworksLite';
  public static GetPlanRates: string = 'literating/GetEmployeeRates';
  public static GetCarrierRatingRules: string =
    'LiteRating/GetCarrierRatingRules?carrierId={carrierId}&stateId={stateId}&effectiveDate={effectiveDate}&userRoleId={userRoleId}';
}

export class NQSQuoteApiMethod {
  public static GetContributionDetail: string =
    'Bundle/GetNHWSBundleContribution';
}

export class NewHireAPIMethod {
  public static GetNewHireDetail: string = 'newhire/GetByGroupId/{groupId}';
  public static GetNewHireDetailById: string =
    'newhire/{Id}/{allowCompletedRecords}';
  public static GenerateEnrollmentWorksheet: string =
    'newhire/GenerateEnrollmentWorksheet/{Id}';

  public static PostNewHireDetail: string = 'newhire/newHireDetails/{Id}';
  public static SendPdf: string = 'newhire/SendPDF/{Id}';
  public static SaveMasterCensus: string = 'newhire/SaveMasterCensus';
  public static getSupportedBrowsers: string = 'newhire/supportedbrowsers';

  public static getSupportedLanguages: string = 'newhire/GetSupportedLanguages';
}

export class UserApiMethod {
  public static GetAgencyDetails: string = 'agency/userId/{userId}';
  public static GetUserInformation: string = 'users/{userId}/user-details';
  public static GetBrokerAgencyDetails: string = 'agency/broker/{brokerId}';
  public static GetCarrierLogo: string = 'carrierlogos/SIQ';
  public static GetExternalLinkById: string = 'externallink/{id}';
  public static LogoFilePath: string = 'carrierlogos/{*filePath}';
}

export class GetPlansApiMethod {
  public static GetPlans: string = 'literating/GetQuotablePlans';
}

export class QuoteLiteMethod {
  public static AddGroup: string = 'group';
  public static GetFinalQuoteId: string = 'quotes/{censusGroupId}/FinalQuoteId';
  public static GetFinalQuoteSelections: string =
    'quotes/{quoteId}/final/selections';
  public static GetQuoteStatus: string = 'quotes/{quoteId}/status';
  public static GetContributionDetail: string =
    'Bundles/GetNHWSBundleContribution';
}
